( function () {
	'use strict';

	function slideContainer () {
		return {
			'restrict' : 'A',
			'require'  : '^slideToggleBase',
			'link'     : function ( scope, element, attrs, baseCtrl ) {
				baseCtrl.addContainer( element, attrs.startHidden || false );
			}
		};
	}

	angular
		.module( 'app.components' )
		.directive( 'slideContainer', slideContainer );
} )();
